export const AUTH_TOKEN = 'auth_token';
export const REFRESH_TOKEN = 'refresh_token';
export const EXPIRE_TIME = 'expire_time';
export const FIREBASE_TOKEN = 'firebase_token';
export const LANGUAGE_LOCAL = 'language_local';
export const USER_ROLES = 'user_roles';
export const BRANCH_ID = 'branch_id';
export const PERMIT = 'permit';